/// <reference types="./adminUpsertEntity.d.ts" />
import { ErrorType, isEntityNameAsRequested, notOk, ok, } from '@dossierhq/core';
import { adminCreateEntity } from './adminCreateEntity.js';
import { adminUpdateEntity } from './adminUpdateEntity.js';
export async function adminUpsertEntity(schema, authorizationAdapter, databaseAdapter, context, entity, options) {
    const nameResult = await databaseAdapter.adminEntityGetEntityName(context, { id: entity.id });
    if (nameResult.isError() && nameResult.isErrorType(ErrorType.NotFound)) {
        return await createNewEntity(schema, authorizationAdapter, databaseAdapter, context, entity, options);
    }
    else if (nameResult.isError()) {
        return nameResult;
    }
    let entityUpdate = entity;
    if (entity.info.name !== undefined &&
        entity.info.name !== null &&
        isEntityNameAsRequested(nameResult.value, entity.info.name)) {
        // Remove name since we don't to change it the current name is the same but with a #number
        entityUpdate = { ...entityUpdate, info: { ...entityUpdate.info, name: undefined } };
    }
    if (entityUpdate.info?.authKey === undefined || entityUpdate.info.authKey === null) {
        entityUpdate = { ...entityUpdate, info: { ...entityUpdate.info, authKey: '' } };
    }
    const updateResult = await adminUpdateEntity(schema, authorizationAdapter, databaseAdapter, context, entityUpdate, options);
    if (updateResult.isOk()) {
        return ok(updateResult.value);
    }
    else if (updateResult.isErrorType(ErrorType.BadRequest) ||
        updateResult.isErrorType(ErrorType.NotAuthorized) ||
        updateResult.isErrorType(ErrorType.Generic)) {
        return updateResult;
    }
    return notOk.GenericUnexpectedError(updateResult);
}
async function createNewEntity(schema, authorizationAdapter, databaseAdapter, context, entity, options) {
    const createResult = await adminCreateEntity(schema, authorizationAdapter, databaseAdapter, context, entity, options);
    if (createResult.isOk()) {
        return createResult.map((value) => value);
    }
    else if (createResult.isErrorType(ErrorType.Conflict)) {
        return adminUpsertEntity(schema, authorizationAdapter, databaseAdapter, context, entity, options);
    }
    else if (createResult.isErrorType(ErrorType.BadRequest) ||
        createResult.isErrorType(ErrorType.NotAuthorized) ||
        createResult.isErrorType(ErrorType.Generic)) {
        return createResult;
    }
    return notOk.GenericUnexpectedError(createResult);
}
//# sourceMappingURL=adminUpsertEntity.js.map